export enum GISTypes {

    Shared = 0,
    Individual = 1

}

export interface IGISBundleResponse {

    ProductID: number;
    PricingID: number;
    Credits: number;
    Price: number;
    Name: string;
    GisType: GISTypes;

    TaxEnabled: boolean;
    TaxRate: number;
    State: string;
    TaxRateDisplay: string;
    TotalWithTax: number;
    TaxAmount: number;        

}


export class GISBundleResponse implements IGISBundleResponse {

    ProductID: number;
    PricingID: number;
    Credits: number;
    Price: number;
    Name: string;
    GisType: GISTypes;
    
    TaxEnabled: boolean;
    TaxRate: number;
    State: string;
    TaxRateDisplay: string;
    TotalWithTax: number;
    TaxAmount: number; 
}

export class GISBundleResponseArray extends Array<GISBundleResponse> {

    constructor(...items: GISBundleResponse[]) {
        super(...items);
        Object.setPrototypeOf(this, GISBundleResponseArray.prototype);
    }

}